import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface MetroNavItem {
  label: string;
  /** SVG crudo (string) que se renderiza tal cual */
  iconSvg: string;
  /** Ruta o identificador de navegación */
  path: string;
  /** Deshabilitar item */
  disabled?: boolean;
  /** Items hijos para menús desplegables */
  children?: MetroNavItem[];
}

@Component({
  selector: 'app-metro-nav-menu',
  templateUrl: './metro-nav-menu.component.html',
  standalone: false,
    encapsulation: ViewEncapsulation.None, // <-- quita la encapsulación

})
export class MetroNavMenuComponent {
  /** Items de navegación */
  @Input() items: MetroNavItem[] = [];

  /** Path activo para resaltar */
  @Input() activePath: string | null = null;

  /** Ancho del panel (clases tailwind) */
  @Input() widthClass = 'w-80';

  /** Alto mínimo del panel */
  @Input() minHeightClass = 'min-h-[700px]';

  /** Clase de fondo del contenedor */
  @Input() containerBgClass = 'bg-slate-50';

  /** Colores del item activo / default */
  @Input() activeItemClass = 'bg-metro-secondary';
  @Input() textColorClass = 'text-[#0e161b]';

  /** Controla qué menús desplegables están abiertos */
  public openMenus: Set<string> = new Set();

  /** Emite cuando se hace click o Enter sobre un item */
  @Output() navigate = new EventEmitter<string>();

  constructor(private sanitizer: DomSanitizer) {}

  /** Marca el SVG string como seguro para que Angular no lo sanitice */
  getIconSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  onClick(item: MetroNavItem) {
    // Si el item tiene hijos, alternamos el menú desplegable
    if (item.children && item.children.length > 0) {
      this.toggleMenu(item.path);
      return;
    }

    // Si no tiene hijos, navegamos normalmente
    if (!item.disabled) this.navigate.emit(item.path);
  }

  onKeydown(evt: KeyboardEvent, item: MetroNavItem) {
    if (item.disabled) return;

    // Si el item tiene hijos, manejamos la navegación con teclado
    if (item.children && item.children.length > 0) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        this.toggleMenu(item.path);
      }
      return;
    }

    // Si no tiene hijos, navegamos normalmente
    if (evt.key === 'Enter' || evt.key === ' ') {
      evt.preventDefault();
      this.navigate.emit(item.path);
    }
  }

  toggleMenu(path: string) {
    if (this.openMenus.has(path)) {
      this.openMenus.delete(path);
    } else {
      this.openMenus.add(path);
    }
  }

  isMenuOpen(path: string): boolean {
    return this.openMenus.has(path);
  }

  isActive(item: MetroNavItem) {
    return !!this.activePath && this.activePath === item.path;
  }

  trackByPath = (_: number, it: MetroNavItem) => it.path;
}
